export default "__VITE_ASSET__gbI_LKYb__"